var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"menuList",staticClass:"menu-button-list",attrs:{"menuList":_vm.menuList}},_vm._l((this.menuList),function(item,i){return _c('MenuButton',{key:i,class:{
      'button-active': _vm.selectedIndex === i,
      'button-inactive': _vm.selectedIndex !== i,
    },attrs:{"bt-name":item.name},nativeOn:{"click":function($event){return _vm.handleSelect(i, item.path)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }